import "./Modal.scss";
import "./QuickBookModal.scss";
import { useEffect } from "react";
import PhoneInput from "../Booking/PhoneInput";

function QuickBookModal({
  bookingModalOpen,
  selectedBoat,
  bookingForm,
  slots,
  fullDay,
  summerTime,
  today,
  onClose,
  onBookingChange,
  onBookingDateChange,
  isBookingFormValid,
  onBookingSubmit,
  setBookingForm,
  destinations,
  allTimeSlots,
  allSummerTimeSlots,
  allGlobalDestinations,
}) {
  useEffect(() => {
    if (bookingModalOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [bookingModalOpen]);

  if (!bookingModalOpen || !selectedBoat) return null;

  const formatTime = (t) => {
    if (!t) return "";
    const [h, m] = t.split(":").map(Number);
    const period = h >= 12 ? "pm" : "am";
    const hour = h % 12 || 12;
    return `${hour}:${m.toString().padStart(2, "0")} ${period}`;
  };

  const getSlotLabel = (slotNum) => {
    const activeSlots = summerTime ? allSummerTimeSlots : allTimeSlots;
    if (!activeSlots || activeSlots.length === 0) {
      const defaults = { 1: "Slot 1", 2: "Slot 2", 3: "Slot 3" };
      return defaults[slotNum] || "";
    }
    const slot = activeSlots[slotNum - 1];
    if (!slot) return "";
    return `${slot.label || `Slot ${slotNum}`} (${formatTime(slot.start_time)} – ${formatTime(slot.end_time)})`;
  };

  const isSlotPast = (slotNum) => {
    if (bookingForm.date !== today) return false;
    const activeSlots = summerTime ? allSummerTimeSlots : allTimeSlots;
    const slot = activeSlots[slotNum - 1];
    if (!slot) return false;
    const now = new Date();
    const [h, m] = slot.start_time.split(':').map(Number);
    const slotStart = new Date();
    slotStart.setHours(h, m, 0, 0);
    return now > slotStart;
  };

  const destObj = (allGlobalDestinations || []).find((d) => d.name === bookingForm.destination);
  const isSlotBased = destObj ? (destObj.isSlotBased !== undefined ? destObj.isSlotBased : true) : bookingForm.destination === "Bayoud";

  return (
    <div
      className="popup-overlay-admin"
      onClick={(e) =>
        e.target.classList.contains("popup-overlay-admin") && onClose()
      }
    >
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h1>Book: {selectedBoat.name}</h1>

        <form onSubmit={onBookingSubmit}>
          <div className="edit-info">
            <label>
              First Name
              <input
                type="text"
                name="bookedBy"
                value={bookingForm.bookedBy}
                onChange={onBookingChange}
                required
                placeholder="First name"
              />
            </label>
            <label>
              Last Name
              <input
                type="text"
                name="lastName"
                value={bookingForm.lastName}
                onChange={onBookingChange}
                placeholder="Last name"
              />
            </label>
            <label>
              Email
              <input
                type="email"
                name="email"
                value={bookingForm.email}
                onChange={onBookingChange}
                placeholder="email@example.com"
              />
            </label>
            <label>
              Phone Number
              <PhoneInput
                value={bookingForm.number}
                onChange={(val) => setBookingForm((prev) => ({ ...prev, number: val }))}
                placeholder="Phone number"
              />
            </label>
            <label>
              Promo Code (optional)
              <input
                type="text"
                name="code"
                value={bookingForm.code}
                onChange={onBookingChange}
                placeholder="Code"
              />
            </label>
            <label>
              Destination
              <select
                name="destination"
                value={bookingForm.destination}
                onChange={onBookingDateChange}
                required
              >
                <option value="">Select a destination</option>
                {destinations &&
                  destinations.map((d) => (
                    <option key={d} value={d}>
                      {d}
                    </option>
                  ))}
              </select>
            </label>
            <label>
              Date
              <input
                type="date"
                name="date"
                value={bookingForm.date}
                onChange={onBookingDateChange}
                required
                min={today}
              />
            </label>
          </div>

          {/* Time slots: Bayoud */}
          {bookingForm.destination && isSlotBased && (
            <div className="quick-slots">
              <h3>Time Slots</h3>
              <div className="slot-options">
                <div className={`slot-option ${(!slots.slot1 || isSlotPast(1)) ? "booked" : ""}`}>
                  <input
                    type="checkbox"
                    id="qslot1"
                    name="slot1"
                    checked={bookingForm.slot1}
                    onChange={onBookingChange}
                    disabled={!slots.slot1 || isSlotPast(1)}
                  />
                  <label htmlFor="qslot1">
                    {getSlotLabel(1)}
                    {isSlotPast(1) ? <span className="booked-tag">Past</span> : !slots.slot1 && <span className="booked-tag">Booked</span>}
                  </label>
                </div>

                <div className={`slot-option ${(!slots.slot2 || isSlotPast(2)) ? "booked" : ""}`}>
                  <input
                    type="checkbox"
                    id="qslot2"
                    name="slot2"
                    checked={bookingForm.slot2}
                    onChange={onBookingChange}
                    disabled={!slots.slot2 || isSlotPast(2)}
                  />
                  <label htmlFor="qslot2">
                    {getSlotLabel(2)}
                    {isSlotPast(2) ? <span className="booked-tag">Past</span> : !slots.slot2 && <span className="booked-tag">Booked</span>}
                  </label>
                </div>

                {!summerTime && (
                  <div className={`slot-option ${(!slots.slot3 || isSlotPast(3)) ? "booked" : ""}`}>
                    <input
                      type="checkbox"
                      id="qslot3"
                      name="slot3"
                      checked={bookingForm.slot3}
                      onChange={onBookingChange}
                      disabled={!slots.slot3 || isSlotPast(3)}
                    />
                    <label htmlFor="qslot3">
                      {getSlotLabel(3)}
                      {isSlotPast(3) ? <span className="booked-tag">Past</span> : !slots.slot3 && <span className="booked-tag">Booked</span>}
                    </label>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Full day: island destinations */}
          {bookingForm.destination && !isSlotBased && (
            <div className="full-day">
              {!bookingForm.date ? (
                <p>Select a date to check availability</p>
              ) : fullDay ? (
                <>
                  <h3>Full day trip available</h3>
                  <div className="slot-option">
                    <input
                      type="checkbox"
                      id="qdropOff"
                      checked={bookingForm.dropOff}
                      onChange={() =>
                        setBookingForm((p) => ({ ...p, dropOff: !p.dropOff }))
                      }
                    />
                    <label htmlFor="qdropOff">Drop-off only</label>
                  </div>
                </>
              ) : (
                <h3 className="unavailable">Full day trip unavailable for this date</h3>
              )}
            </div>
          )}

          <div className="modal-footer">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="save-btn"
              disabled={!isBookingFormValid()}
            >
              Confirm Booking
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default QuickBookModal;
